import MyTable from "../../../Component/MyTable"
import { Alert, Paper, Toolbar, Typography, Box, ButtonGroup, Stack, Switch, FormControlLabel } from "@mui/material";
import { useEffect, useState } from "react";
import { apiResult, getUserSession, } from "../../../Utils/Common";
import { RightDrawer } from "../../../Component/MuiEx";
import { useNavigate, useParams } from "react-router";
import IconButton from "@mui/material/IconButton/IconButton";
import { Beenhere, CurrencyExchange, Edit, NoAccounts, Payment, Person, PersonAdd, PersonOutline, Receipt, Schedule } from "@mui/icons-material";
import EditClassMember from "./EditClassMember";
import apis from "../../../api";
import Recharge from "./Recharge";
import Refund from "./Refund";
import ClassMemberRecords from "./ClassMemberRecords";
import MemberEditForm from "../../member/fragement/MemberEditForm";
import UserEditForm from "../../member/fragement/UserEditForm";
import { LOGO_TEXT_COLOR } from "../../../App/config";
import EditSchedule from "./EditSchedule";
import { getItemsFromObjects, loadCourseCategories } from "../../../Component/DataLoader";
import { CourseLoader } from "../../fragement/CourseSelector";

const ClassMemberList = (props) => {
    const { classid, classobj,  onChange,refresh,onEditClassMember } = props
    const [rightDrawer, setRightDrawer] = useState()
    // const [allSchedule, setAllSchedule] = useState(false)
    const [datas, setDatas] = useState([])
    const [error, setError] = useState()
    const [categories, setCategories] = useState()
    const [courses, setCourses] = useState()
    const [autoCloseRightDraw, setAutoCloseRightDraw] = useState(true)
    getUserSession(apis)
    const loadDatas = () => {
        apis.classmembers(classid).then(ret => {
            apiResult(ret, data => {
                setDatas(data)
            }, setError)
        })
    }
    let initPage = false
    useEffect(() => {
        if (initPage) return
        initPage = true
        loadCourseCategories(apis, (data) => { setCategories(data) }, setError, 1)
        CourseLoader((data) => setCourses(data), apis, false)        
    }, [])
    useEffect(() => {
        loadDatas()
    }, [refresh])

    const handleRightDrawer = () => {
        if (autoCloseRightDraw)
            setRightDrawer(false)
    }

    const handleDelete = (idx, item) => {
        apis.classmemberDelete(item.id).then(ret => {
            apiResult(ret, data => {
                let cc = [...datas]
                cc[idx].status = 0
                setDatas(cc)
                classobj.students -= 1
                onChange && onChange(classobj)
            }, setError)
        })
    }
    const handleEnable = (idx, item) => {
        apis.classmemberPut({ id: item.id, class_id: item.class_id, status: 1 }).then(ret => {
            apiResult(ret, data => {
                let cc = [...datas]
                cc[idx].status = 1
                setDatas(cc)
                classobj.students += 1
                onChange && onChange(classobj)
            }, setError)
        })
    }
    // const handleAfterPay = () => {
    //     loadDatas()
    //     setRightDrawer()
    //     setAutoCloseRightDraw(true)
    // }
    // const handlePay = (idx, item) => {
    //     setAutoCloseRightDraw(false)
    //     setRightDrawer(<Recharge memberId={item.member_id} unit={item.lesson_price} classId={item.class_id} onClose={() => setRightDrawer()} onSubmit={handleAfterPay} />)
    // }
    // const handleRefund = (idx, item) => {
    //     setAutoCloseRightDraw(false)
    //     setRightDrawer(<Refund item={item} onClose={() => setRightDrawer()} onSubmit={handleAfterPay} />)
    // }
    const handleEditMember = (id) => {
        setRightDrawer(<MemberEditForm id={id} onClose={() => setRightDrawer()} title="Edit Member" />)
    }
    const handleEditUser = (idx) => {
        if (datas[idx].member.parent) {
            setRightDrawer(<UserEditForm user={datas[idx].member.parent} onClose={() => setRightDrawer()} title="Edit Parent" />)
        } else {
            apis.loadParent(datas[idx].member.user_id).then(ret => {
                apiResult(ret, data => {
                    datas[idx].member.parent = data.user_profile
                    data.user_profile.id = data.id
                    data.user_profile.area_id = data.area_id
                    console.log(data.user_profile)
                    setRightDrawer(<UserEditForm user={data.user_profile} onClose={() => setRightDrawer()} title="Edit Parent" />)
                }, setError)
            })
        }
    }
    const handleTransaction = (user_id, id) => {
        window.open("/member/balancelog/" + user_id + "/" + id, 'transaction_log')
    }
    const handleAfterScheduleEdit = (idx, schedule) => {
        setAutoCloseRightDraw(true)
        setRightDrawer(false)
        window.location.reload()
    }
    const handleEditSchedule = () => {
        setAutoCloseRightDraw(false)
        setRightDrawer(<EditSchedule schedule={{ id: 0 }} classid={classid} onAfterEdit={(data) => { handleAfterScheduleEdit() }} onClose={() => { setRightDrawer(false) }} />)
    }
    const handleCategoryView = (id)=>{

    }
    const handleCourseView = (id)=>{

    }
    const TableHeader = [
        { name: 'id', showName: 'ID' },
        {
            name: 'name', showName: 'Name', func: (v, idx, item) => {
                return <Stack direction={"column"}>
                    <Typography sx={{ cursor: 'pointer', color: LOGO_TEXT_COLOR }} onClick={() => { handleEditMember(item.member.id) }}>{item.member.name}
                        <IconButton sx={{ mt: -0.5 }} title={"Parent Information"} size="small" onClick={() => { handleEditUser(idx) }}><PersonOutline /></IconButton>
                        <IconButton sx={{ mt: -0.5 }} title={"Transaction information"} onClick={() => { handleTransaction(item.member.user_id, item.member.id) }} size="small"><Receipt fontSize="8px" /> </IconButton>
                    </Typography>
                    <Typography variant="body2" sx={{color:"gray"}}>Join date: {item.join_date}</Typography>
                </Stack>
            }
        },
        {
            name: 'course', showName: 'Course', func: (v, idx, item) => {
                let cid = item.member_course?.course_package?.category_id
                let ccid = item.member_course?.course_package?.course_id
                let c = cid > 0 && getItemsFromObjects(categories, cid)
                let cc = ccid>0 &&  getItemsFromObjects(courses,ccid)
                return <Stack direction={"column"}>
                    {c && <Typography sx={{ cursor: 'pointer'}} onClick={() => { handleCategoryView(c.id) }}>{c.name}({c.code})</Typography>}
                    {cc && <Typography sx={{ cursor: 'pointer'}} onClick={() => { handleCourseView(cc.id) }}>{cc.name}({cc.code})</Typography>}
                </Stack>
                // return cid > 0 && (getItemsFromObjects(categories, cid).name + "/" + (ccid > 0 ? getItemsFromObjects(courses, ccid).name : "*"))
            }
        },
        {
            name: 'lessons', showName: 'Lessons/Hours', func: (v, idx, item) => {
                let rr = item.member_course?.remained
                let tt = item.member_course?.total
                let billtype = item.member_course?.course_package?.billtype
                let minutes = item.member_course?.course_package?.minutes
                return <Stack direction={"column"}>
                    <Typography >{billtype == 0 ? (rr + " lessons (" + (minutes / 60).toFixed(1) + " h)") : ((rr / 60).toFixed(1) + " hours")}</Typography>
                    <Typography variant="body2" sx={{color:"gray"}}>Total: {billtype == 0 ? (tt + " lessons") : ((tt / 60).toFixed(1) + " hours")}</Typography>
                </Stack>
                // return billtype == 0 ? (rr + " lessons (" + (minutes / 60).toFixed(1) + " h)") : ((rr / 60).toFixed(1) + " hours")
            }
        },
        {
            name: 'option', showName: 'Options', func: (v, idx, item) => {
                return <ButtonGroup size="small" variant="contained" aria-label="outlined primary button group">
                    <IconButton size="small" onClick={() => item.status != 0 ? handleDelete(idx, item) : handleEnable(idx, item)}>{item.status == 0 ? <NoAccounts fontSize="10px" /> : <Beenhere fontSize="10px" />}</IconButton>
                    <IconButton size="small" onClick={() => onEditClassMember&&onEditClassMember(idx, item)}><Edit fontSize="10px" /></IconButton>
                    {/* {Number(item.fee) > Number(item.paid) && <IconButton size="small" onClick={() => handlePay(idx, item)} title="Recharge"><Payment fontSize="10px" /></IconButton>} */}
                    {/* {Number(item.remained_lessons) > 0 && <IconButton size="small" onClick={() => handleRefund(idx, item)}><CurrencyExchange fontSize="10px" /></IconButton>} */}
                </ButtonGroup>
            }
        }
    ]
    return (
        <>
            {error && <Alert severity={"warning"} sx={{ width: '100%', marginTop: "5px", mb: 2 }} onClose={() => setError()}>{error}</Alert>}
            {/* <Paper sx={{ marginBottom: 2 }}>
                <Toolbar>
                    <Typography sx={{ ml: 2 }} variant="h6" component='h6'>Members</Typography>
                    <Typography sx={{ flex: '1 1 10%' }} variant="h6" component="div" ></Typography>
                    <FormControlLabel control={<Switch onChange={(e) => setAllSchedule(e.target.checked)} />} label="All schedule" />
                    <IconButton onClick={handleEditSchedule} title="Add Schedule"><Schedule /></IconButton>
                    <IconButton onClick={handleAdd} title="Add Member"><PersonAdd /></IconButton>
                </Toolbar>
            </Paper> */}

            {datas.length == 0 && <Alert severity={"info"}>Ops! There is not any lesson</Alert>}
            {datas.length > 0 && <MyTable
                height={650}
                rows={datas}
                totalRow={datas.length}
                headers={TableHeader}
                checkbox={false}
                rowsPerPage={datas.length}
                showPageination={false}
            />}
            {/* {datas.length>0 && <ClassMemberRecords listAll={allSchedule} members={datas} classid={classid} onLoaded={onLoaded}/>} */}
            <RightDrawer toggleDrawer={handleRightDrawer} open={rightDrawer ? true : false}>
                {rightDrawer}
            </RightDrawer>
        </>

    )
}
export default ClassMemberList